require('./bootstrap')
require('./delete')
const {get, isEmpty} = require("lodash")

window.$ = window.jQuery = require('jquery')
const Inputmask = require('inputmask').default || require('inputmask')
$.fn.inputmask = function (maskOrOptions, options = {}) {
  return this.each(function () {
    if (typeof maskOrOptions === 'string') {
      Inputmask(maskOrOptions, options).mask(this)
      return
    }

    Inputmask(maskOrOptions || {}).mask(this)
  })
}

window.datepicker = require('jquery-ui/ui/widgets/datepicker')
require('jquery-ui/ui/i18n/datepicker-ru')
require('./jquery.datepicker.extension.range.min')

window.ClassicEditor = require('@ckeditor/ckeditor5-build-classic')
require('@ckeditor/ckeditor5-build-classic/build/translations/ru')

$(document).ready(function () {
  $('input.tel-masked').inputmask('+7 (999) 999-9999')



  axios.post('/get_weekend')
    .then(response => {
      const weekend = []
      if (response.status === 200) {
        response.data.forEach(function (el) {
          //при получении дня недели под номером 7(воскресенье) меняет на 0(датапикер считает воскресенье как 0)
          weekend.push(el === 7 ? 0 : el)
        })
      }

      $('#customersServiceTime').datepicker({
        defaultDate: null,
        dateFormat: 'dd.mm.yy',
        minDate: dateToday,
        maxDate: '+2w',
        beforeShowDay: (date) => {
          return [weekend.indexOf(date.getDay()) === -1]
        },
      }).change(function () {
        $regTimeSelect.attr('disabled', true)

        axios.post('/' + $(this).attr('data-service-id') + '/get_times', {
          'regDate': $(this).val()
        }).then(({data}) => {
          $regTimeSelect.find('option').remove()
          $regTimeSelect.append($('<option/>').text('Выбрать время').attr('disabled', true))
          data.freeTimes.forEach((item) => {
            $regTimeSelect.append($('<option/>').val(item.value).text(item.name))
          })
          $regTimeSelect.removeAttr('disabled')
        }).catch((e) => {
          console.error(e)
          alert('При загрузке ')
        })
      })
    })

  let dateToday = new Date

  $('#multipleDates').datepicker({
    defaultDate: '',
    range: 'multiple',
    onSelect: function (dateText, inst, extensionRange) {
      $('#dates').val(extensionRange.datesText)
    },
    changeMonth: true,
    changeYear: true,
    minDate:dateToday,
  })
  const $regTimeSelect = $('select#regTime')

  $('#birth_date').inputmask({
    alias: 'datetime',
    inputFormat: 'dd.mm.yyyy',
    placeholder: 'дд.мм.гггг',
  }).datepicker({
    dateFormat: 'dd/mm/yyyy',
    changeMonth: true,
    changeYear: true,
    yearRange: '-90:+0',
    maxDate: dateToday
  })
})